// removed by extract-text-webpack-plugin
module.exports = {"container":"UpcomingList__container___1TE4R"};